import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../_components/Loading';
import { NoData } from '../_components/NoData';
import { courseService } from '../_services/course.service';
import { CourseBox } from './CourseBox';
import './home.css';

export const PopularCourses = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [courseData, setCourseData] = useState([]);
  const [query, setQuery] = useState({
    pageVo: {
      pageNo: 1,
      noOfItems: 6,
    },
    searchKey: '',
  });

  useEffect(() => {
    getAllCourse(1);
  }, []);
  // to get all course details
  const getAllCourse = (pageNo, queryTemp) => {
    let queryNew = queryTemp ? queryTemp : query;
    queryNew.pageVo.pageNo = pageNo;
    setQuery(queryNew);
    setIsLoading(true);

    queryNew.status = 1;
    queryNew.isactive = 1;
    courseService.courseList(queryNew).then(
      (res) => {
        setIsLoading(false);
        setCourseData(res?.data?.rows);
      },
      (err) => {
        console.error('courseList err', err);
        setIsLoading(false);
      },
    );
  };
  return (
    <div className='mt-5'>
      <div className='d-flex align-items-center mb-5 justify-content-between headcontainer'>
        <div className='home_head '>Popular Courses </div>
        <h6 className='viewalltitle mb-0' onClick={() => navigate('/courselist')}>
          View All
        </h6>
      </div>
      {!isLoading && (
        <div className='d-flex align-items-center gap-1 justify-content-between'>
          <div className=''>
            <div className='d-flex flex-wrap gap-4 courselist'>
              {courseData?.map((course, index) => {
                return <CourseBox courseData={course} key={index} />;
              })}
            </div>
          </div>
          <div className='viewallcontainer'>
            <div className='viewallbtn' onClick={() => navigate('/courselist')}>
              <img src={'/img/arrow_left_circle.png'} className='viewallicon' />
            </div>
            <h6 className='viewalltitle' onClick={() => navigate('/courselist')}>
              View All
            </h6>
          </div>
        </div>
      )}
      {isLoading && !courseData?.length && <Loading />}
      {!isLoading && !courseData?.length && <NoData text='No Course Found' />}
    </div>
  );
};
